import { PostalCodeByCountryDTO } from 'src/app/shared/interfaces/contacts/dtos/postal-code-by-country-dto.interface';
import { CountryDto } from 'src/app/shared/interfaces/countries/country-dto.interface';

export class PostalCodeByCountry {
  id: number | string;
  codePostal: string;
  localite: string;
  autoCompleteField: string;
  pays?: CountryDto;
  isFromAnotherAPI: boolean;
  constructor(data: PostalCodeByCountryDTO) {
    Object.assign(this, data);
    this.autoCompleteField = this.codePostal + ' - ' + this.localite;
    this.isFromAnotherAPI = false;
  }
}
